/* OCB relaunch: product page. Organizes the existing product description into panels,
   surfaces the tagline / medal / spec line, and adds a sticky add-to-cart bar. */
(function () {
  var LABELS = [
    { key: 'notes', re: /^(tasting notes|fragrance profile|scent profile|flavor profile|notes)\s*:?\s*/i },
    { key: 'enjoy', re: /^(how to enjoy|how to use|serving suggestions?|use it|how to wear)\s*:?\s*/i },
    { key: 'ingredients', re: /^ingredients\s*:?\s*/i },
    { key: 'spec', re: /^(net weight|net wt|best by|size|burn time)\s*:?\s*/i }
  ];
  var TITLES = { story: 'The story', notes: 'Tasting notes', enjoy: 'How to enjoy', ingredients: 'Ingredients' };

  function text(el) { return (el.textContent || '').replace(/\s+/g, ' ').trim(); }

  function build(root) {
    if (root.dataset.ready) return; root.dataset.ready = '1';
    var rawEl = root.querySelector('.ocbp-raw'); if (!rawEl) return;
    // the description lives in a <template> so its headings aren't part of the page; copy it into a working div
    var raw = rawEl;
    if (rawEl.content) { raw = document.createElement('div'); raw.appendChild(rawEl.content.cloneNode(true)); }
    // the product title is the page's only H1; demote any H1 written inside a description
    [].slice.call(raw.querySelectorAll('h1')).forEach(function (h) { var h2 = document.createElement('h2'); h2.innerHTML = h.innerHTML; h.parentNode.replaceChild(h2, h); });
    var type = (root.dataset.type || '').toLowerCase();
    if (/perfume|fragrance|candle/.test(type)) TITLES.notes = 'Fragrance profile';
    if (/candle|soap|lip|balm|oil/.test(type)) TITLES.enjoy = 'How to use';
    // Split paragraphs that use <br> line breaks into separate lines
    var nodes = [];
    [].slice.call(raw.children).forEach(function (el) {
      if (/<br\s*\/?>/i.test(el.innerHTML) && !/^(UL|OL)$/.test(el.tagName)) {
        el.innerHTML.split(/<br\s*\/?>/i).forEach(function (part) {
          var p = document.createElement('p'); p.innerHTML = part; if ((p.textContent || '').trim()) nodes.push(p);
        });
      } else nodes.push(el);
    });
    var groups = { story: [], notes: [], enjoy: [], ingredients: [] }, specs = [], eyebrow = '', tagline = '', medal = '';
    var current = 'story';
    nodes.forEach(function (n, i) {
      var t = text(n); if (!t) return;
      // First line with bullets is a keyword/eyebrow line
      if (i === 0 && t.indexOf('•') > -1 && t.length < 140) { eyebrow = t; return; }
      if (!tagline && i < 3 && t.length < 70 && /[.!]$/.test(t) && current === 'story' && groups.story.length === 0) { tagline = t; return; }
      var m = t.match(/[^.]*\b(gold|silver|bronze)\b[^.]*world marmalade awards[^.]*\./i);
      if (m && !medal) medal = m[0].trim();
      // bullet spec lines like "11 oz • Cotton Wick • Soy Wax"
      if (t.indexOf('•') > -1 && t.length < 160 && i > 0) { t.split('•').forEach(function (s) { s = s.trim(); if (s) specs.push(s); }); return; }
      for (var k = 0; k < LABELS.length; k++) {
        if (LABELS[k].re.test(t)) {
          var rest = t.replace(LABELS[k].re, '');
          if (LABELS[k].key === 'spec') { specs.push(t); return; }
          current = LABELS[k].key;
          if (rest) { var p = document.createElement('p'); p.textContent = rest; groups[current].push(p); }
          return;
        }
      }
      if (/^made in (a|the)\b/i.test(t)) { var mp = document.createElement('p'); mp.textContent = t; groups.ingredients.push(mp); return; }
      groups[current].push(n.cloneNode(true));
    });

    var out = root.querySelector('.ocbp-out');
    if (specs.length) {
      var sp = document.createElement('div'); sp.className = 'ocbp-spec';
      specs.slice(0, 8).forEach(function (s) { var e = document.createElement('span'); e.textContent = s; sp.appendChild(e); });
      out.appendChild(sp);
    }
    ['story', 'notes', 'enjoy', 'ingredients'].forEach(function (key, idx) {
      if (!groups[key].length) return;
      var d = document.createElement('details'); d.className = 'ocbp-panel ocbp-panel--' + key;
      if (key === 'story' || key === 'notes') d.open = true;
      var s = document.createElement('summary'); s.textContent = TITLES[key]; d.appendChild(s);
      var b = document.createElement('div'); b.className = 'ocbp-panel__body';
      var list = groups[key];
      if (key === 'story' && list.length > 3) {
        list.slice(0, 2).forEach(function (n) { b.appendChild(n); });
        var more = document.createElement('div'); more.hidden = true; list.slice(2).forEach(function (n) { more.appendChild(n); }); b.appendChild(more);
        var btn = document.createElement('button'); btn.type = 'button'; btn.className = 'ocbp-more'; btn.textContent = 'Read more';
        btn.addEventListener('click', function () { more.hidden = false; btn.remove(); });
        b.appendChild(btn);
      } else { list.forEach(function (n) { b.appendChild(n); }); }
      d.appendChild(b); out.appendChild(d);
    });

    var top = document.querySelector('[data-ocbp-top]');
    if (top) {
      if (eyebrow) { var e = document.createElement('p'); e.className = 'ocbp-eyebrow'; e.textContent = eyebrow.replace(/\s*•\s*/g, ' · '); top.appendChild(e); }
      if (tagline) { var tg = document.createElement('p'); tg.className = 'ocbp-tagline'; tg.textContent = tagline; top.appendChild(tg); }
      if (medal) {
        var md = document.createElement('div'); md.className = 'ocbp-medal';
        var words = { one: 1, two: 2, three: 3, four: 4, five: 5 }, count = (medal.match(/\b(one|two|three|four|five|\d)\b/i) || [])[1];
        var num = count ? (words[count.toLowerCase()] || count) : '★';
        md.innerHTML = '<i>' + num + '</i><span></span>';
        var mt = medal.replace(/^this marmalade\s+/i, '').replace(/\s+in the united kingdom/i, '').replace(/\.$/, ''); md.querySelector('span').textContent = mt.charAt(0).toUpperCase() + mt.slice(1);
        top.appendChild(md);
      }
    }
  }

  function sticky() {
    var btn = document.querySelector('.btn--add-to-cart'); var bar = document.querySelector('[data-ocbp-sticky]');
    if (!btn || !bar || bar.dataset.ready) return; bar.dataset.ready = '1';
    var go = bar.querySelector('button');
    function label() { var t = text(btn); go.textContent = /add/i.test(t) ? t.replace(/\s*·\s*/, ' · ') : 'Add to cart'; go.disabled = btn.disabled; }
    label(); new MutationObserver(label).observe(btn, { childList: true, subtree: true, attributes: true, characterData: true });
    go.addEventListener('click', function () { btn.click(); });
    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (es) { es.forEach(function (en) {
        var past = !en.isIntersecting && en.boundingClientRect.top < 0; bar.classList.toggle('show', past); bar.setAttribute('aria-hidden', !past);
      }); }).observe(btn);
    }
  }

  function init() { [].forEach.call(document.querySelectorAll('[data-ocbp-details]'), build); sticky(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', init);
})();
